import PlatformActionTypes from "./platform.types"

export const setCurrentPlatformVersion = payload => ({
  type: PlatformActionTypes.SET_CURRENT_VERSION,
  payload,
})
